import React, { type FC, type ReactNode, useMemo, useState } from "react";
import { MembershipStatus } from "../types/membership";
import MembershipContext from "../context/membershipContext";
import { MembershipContextType } from "../context/types/membershipContextType";

interface MembershipProviderProps {
  children: ReactNode;
}

const MembershipProvider: FC<MembershipProviderProps> = ({ children }) => {
  const [membershipStatus, setMembershipStatus] =
    useState<MembershipStatus | null>(null);

  // Update membership status from external source (AuthProvider)
  const updateMembershipStatus = (status: MembershipStatus | null) => {
    setMembershipStatus(status);
  };

  const membershipInfo = useMemo((): MembershipContextType => {
    return { membershipStatus, updateMembershipStatus };
  }, [membershipStatus]);

  return (
    <MembershipContext.Provider value={membershipInfo}>
      {children}
    </MembershipContext.Provider>
  );
};

export default MembershipProvider;
